import { useEffect } from "react";
import { useAppDispatch, useAppSelector } from "../../../redux/hooks";
import { API } from "../../../services/services";
import { responseValidator } from "../../helpers";
import { setPlayList } from "../../../redux/slices/videoDataSlice";
import { conditions } from "../../conditions/conditions";
import { ConditionName } from "../../../interfaces/enums";
import { shallowEqual } from 'react-redux'
import { getPlaylistHeader } from "redux-share/actions";

const useGetPlayList = () => {
    const dispatch = useAppDispatch();

    const { isFetchDetails } = useAppSelector(({ videoData: { isFetchDetails } }) => ({ isFetchDetails }), shallowEqual);
    const {loadedFragmentsCount} = useAppSelector(({ controller: { loadedFragmentsCount } }) => ({ loadedFragmentsCount }), shallowEqual);
    useEffect(() => {
        if (conditions(ConditionName.getPlayList) && conditions(ConditionName.hasPermittedLoadedFragment)) {
            const handleGetPlayList = async () => {
                const { data, status } = await getPlaylistHeader(API().playList);
                if (responseValidator(status)) {
                    const playListVideos: any = [];
                    for await (const result of data.results) {
                        const singlePlayList: any = { title: result.title, id: result.id, count: result.count };
                        playListVideos.push(singlePlayList)
                    }
                    dispatch(setPlayList(playListVideos))
                } else dispatch(setPlayList([]))
            }
            handleGetPlayList()
        }

    }, [isFetchDetails, loadedFragmentsCount.length])

}

export default useGetPlayList;